import styled from 'styled-components';

export const Panel = styled.div<{ $linked?: boolean }>`
  padding: ${({ theme }) => theme.spacing[4]};
  background-color: ${({ theme }) => theme.colors.bgMuted};
  border-radius: ${({ theme }) => theme.radii.md};
  margin-bottom: ${({ theme }) => theme.spacing[5]};
  border-left: 4px solid ${({ theme, $linked }) =>
    $linked ? theme.colors.success : theme.colors.secondary};
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.spacing[3]};
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const MetadataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: ${({ theme }) => theme.spacing[3]};
`;

export const MetadataItem = styled.div<{ $wide?: boolean }>`
  ${({ $wide }) => $wide && 'grid-column: 1 / -1;'}
`;

export const MetadataLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-bottom: ${({ theme }) => theme.spacing[1]};
`;

export const MetadataValue = styled.div`
  font-size: 0.875rem;
`;
